import { useNavigate, useParams } from "react-router-dom";
import { useStore } from "../../../Components/StateProvider";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import {
  ErrorAlert,
  GetDateTimeFormat,
  GetRecords,
  RupeeFormat,
  UploadFile,
  URLPRIFIX,
  WarningAlert,
} from "../../../functions/api";
import AccountsLayout from "../AccountsLayout";

const CustomerLedger = () => {
  const { companyId } = useParams();
  const getrecord = `/users/users/${companyId}`;
  const attachment_Prefix = "Journal_";
  const store = useStore();

  // *initial values
  const init = {
    entries: [],
    totalDebit: [],
    totalCredit: [],
    fromDate: "",
    ToDate: "",
  };
  const initProps = {
    add: false,
    delete: false,
    on_off: false,
    print: false,
    update: false,
    view: false,
    entries: {},
    totalDebit: {},
    totalCredit: {},
    fromDate: {},
    ToDate: {},
  };

  // *states declaration for records and props
  const [Record, setRecord] = useState(init);
  const [props, setprops] = useState(initProps);
  const [searchTerm, setSearchTerm] = useState("");


  useEffect(() => {
    store.setmodule("customerledger", init);

    const dateTime = GetDateTimeFormat();
    const savedSearch = localStorage.getItem("customerLedgerSearch");

    if (savedSearch) {
      setSearchTerm(savedSearch);
    }


    handleMultiFieldChange({
      fromDate: dateTime.yearStartDate + "Z",
      ToDate: dateTime.yearEndDate + "Z",
    });

    loadRecord(dateTime.yearStartDate + "Z", dateTime.yearEndDate + "Z");
  }, []);

  function loadRecord(fromDate, ToDate) {
    GetRecords(
      `/api/v2/accounting/customerupdatedreport/${companyId}?startDate=${fromDate || Record.fromDate
      }&endDate=${ToDate || Record.ToDate}`
    ).then((res) => {
      console.log("accounting/ledger", res);
      if (res?.success) {
        // Initialize 'show' property for each customer to control expansion
        // and also 'show' for invoices to control payment expansion
        const updatedEntries = res?.record.map((customer) => ({
          ...customer,
          show: false, // Default to collapsed for customer
          invoices: customer.invoices
            ? customer.invoices.map((invoice) => ({
              ...invoice,
              show: false, // Default to collapsed for invoice payments (renamed from showPayments for consistency)
            }))
            : [],
        }));
        handleMultiFieldChange({
          entries: updatedEntries,
        });
      }
    });
  }

  // Toggle for customer expansion (to show invoices)
  const toggleCustomerExpansion = (customerId) => {
    setRecord((prev) => {
      const newEntries = prev.entries.map((customer) =>
        customer.customerid === customerId
          ? { ...customer, show: !customer.show }
          : customer
      );
      return { ...prev, entries: newEntries };
    });
  };

  // Toggle for invoice expansion (to show payments)
  const toggleInvoiceExpansion = (customerId, invoiceId) => {
    setRecord((prev) => {
      const newEntries = prev.entries.map((customer) => {
        if (customer.customerid === customerId) {
          return {
            ...customer,
            invoices: customer.invoices.map((invoice) =>
              invoice.invoiceId === invoiceId
                ? { ...invoice, show: !invoice.show } // Toggle invoice's own 'show'
                : invoice
            ),
          };
        }
        return customer;
      });
      return { ...prev, entries: newEntries };
    });
  };
  useEffect(() => {
    console.log("Record State change -> ", Record);
    console.log("Props State change -> ", props);
  }, [Record, props]);


  useEffect(() => {
    if (searchTerm) {
      localStorage.setItem("customerLedgerSearch", searchTerm);
    } else {
      localStorage.removeItem("customerLedgerSearch");
    }
  }, [searchTerm]);





  function handleFieldChange(fieldName, value) {
    setRecord((prev) => {
      return { ...prev, [fieldName]: value };
    });
  }
  function handleMultiFieldChange(value = {}) {
    setRecord((prev) => {
      for (let fieldName in value) {
        prev[fieldName] = value[fieldName];
      }
      return { ...prev };
    });
  }
  function HandlePropsChange(fieldName, value = {}) {
    setprops((prev) => {
      let oldprop = prev[fieldName];

      for (let prophead in value) {
        oldprop[prophead] = value[prophead];
      }
      prev[fieldName] = oldprop;
      return { ...prev };
    });
  }



  const ExportExcel = () => {
    try {
      if (!Record || !Record.entries || Record.entries.length === 0) {
        WarningAlert("No data available to export.");
        return;
      }
      const formatEntries = (entries) => {
        return entries.reduce((formatted, entry) => {
          const formattedEntry = {
            Name: entry.customerName,
            AccountName: entry.ledgerName,
            InvoiceDate: "",
            InvoiceDueDate: "",
            Debit: entry.debit,
            Credit: entry.credit,
          };

          formatted.push(formattedEntry);
          if (entry.transactions && entry.transactions.length > 0) {
            entry.transactions.forEach((subEntry) => {
              const invoiceDate = subEntry.invoice_date
                ? new Date(subEntry.invoice_date)
                : null;
              const dueDate = subEntry.invoice_due_date
                ? new Date(subEntry.invoice_due_date)
                : null;

              const formattedInvDate =
                invoiceDate && !isNaN(invoiceDate.getTime())
                  ? invoiceDate.toISOString().split("T")[0]
                  : "";
              const formattedDueDate =
                dueDate && !isNaN(dueDate.getTime())
                  ? dueDate.toISOString().split("T")[0]
                  : "";

              formatted.push({
                Name: subEntry.referenceno,
                AccountName: subEntry.ledgerName,
                InvoiceDate: formattedInvDate,
                InvoiceDueDate: formattedDueDate,
                Debit: subEntry.transactionTotalCredit,
                Credit: subEntry.transactionTotalCredit,
              });
            });
          }

          return formatted;
        }, []);
      };

      const formattedEntries = formatEntries(Record.entries);

      const fromDate = new Date(Record.fromDate);
      const toDate = new Date(Record.ToDate);
      const formattedFromDate = fromDate.toISOString().split("T")[0];
      const formattedToDate = toDate.toISOString().split("T")[0];

      let rows = [];
      rows.push(["", "", ` ${formattedFromDate} - ${formattedToDate} `]);
      rows.push(["", ""]);
      const ws = XLSX.utils.aoa_to_sheet(rows);
      XLSX.utils.sheet_add_json(ws, formattedEntries, { origin: -1 });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Entries");
      XLSX.writeFile(wb, "Customer Ledger.xlsx");
    } catch (error) {
      console.error("Error generating Excel file:", error);
      WarningAlert("An error occurred while generating the Excel file.");
    }
  };
  const ExportPDF = () => {
    try {
      if (!Record || !Record.entries || Record.entries.length === 0) {
        WarningAlert("No data available to export.");
        return;
      }
      const doc = new jsPDF("l", "mm", "a4");
      const data = Record;
      const HeaderTitle = "Customer LEDGER";
      const logo = "/Assets/images/Logo.png";
      const textWidth = doc.getTextWidth(HeaderTitle);
      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;
      const xPosition = (pageWidth - textWidth) / 2;

      let yPosition = 20;

      doc.addImage(logo, "PNG", 15, 5, 15, 15);

      const fromDate = new Date(Record?.fromDate);
      const toDate = new Date(Record?.ToDate);
      const formattedFromDate = fromDate.toISOString().split("T")[0];
      const formattedToDate = toDate.toISOString().split("T")[0];
      const dateRange = `${formattedFromDate} - ${formattedToDate}`;

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("ABSOLUTE LEGAL", 8, 25);
      doc.text("LAW FIRM", 12, 30);
      doc.setFontSize(16);
      doc.text(HeaderTitle, xPosition, yPosition);
      yPosition += 10;

      doc.setFontSize(11);
      doc.setLineWidth(0.2);
      const textWidth1 = 60;
      const textHeight = 8;
      doc.rect(220, 5, textWidth1 + 2, textHeight);
      doc.text(dateRange, 230, 10);

      yPosition += 15;
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text("Name", 20, yPosition);
      doc.text("Account Name", 70, yPosition);
      doc.text("Invoice Date", 140, yPosition);
      doc.text("Invoice DueDate", 175, yPosition);
      doc.text("Debit", 225, yPosition);
      doc.text("Credit", 265, yPosition);
      doc.setDrawColor(169, 169, 169);
      doc.setLineWidth(0.2);
      doc.line(10, yPosition + 2, pageWidth - 10, yPosition + 2);
      yPosition += 10;

      doc.setFont("helvetica", "normal");
      data.entries.forEach((entry) => {
        doc.setFontSize(11);
        if (yPosition > pageHeight - 20) {
          doc.addPage();
          yPosition = 20;
          doc.setLineWidth(0.2);
          doc.line(10, yPosition + 2, pageWidth - 10, yPosition + 2);
          yPosition += 10;
        }
        doc.text(entry.customerName, 20, yPosition);
        doc.text(entry.ledgerName, 70, yPosition);
        doc.text(`${entry.totalLedgerDebit}`, 225, yPosition);
        doc.text(`${entry.totalLedgerCredit}`, 265, yPosition);
        doc.setLineWidth(0.05);
        doc.line(10, yPosition + 2, pageWidth - 10, yPosition + 2);
        yPosition += 10;
        doc.setFont("helvetica", "normal");
        entry.transactions.forEach((subEntry) => {
          doc.setTextColor("#000042");
          doc.setFontSize(11);
          const invoiceDate = subEntry.invoice_date
            ? new Date(subEntry.invoice_date)
            : "";
          const dueDate = subEntry.invoice_due_date
            ? new Date(subEntry.invoice_due_date)
            : "";

          const formattedInvDate =
            invoiceDate && !isNaN(invoiceDate.getTime())
              ? invoiceDate.toISOString().split("T")[0]
              : "";
          const formatteddueDate =
            dueDate && !isNaN(dueDate.getTime())
              ? dueDate.toISOString().split("T")[0]
              : "";
          if (yPosition > pageHeight - 20) {
            doc.addPage();
            yPosition = 20;
          }
          doc.setFontSize(11);
          doc.text(`${subEntry.referenceno}`, 20, yPosition);
          doc.text(`${subEntry.ledgerName}`, 70, yPosition);
          doc.text(`${formattedInvDate}`, 140, yPosition);
          doc.text(`${formatteddueDate}`, 175, yPosition);
          doc.text(`${subEntry.transactionTotalDebit}`, 225, yPosition);
          doc.text(`${subEntry.transactionTotalCredit}`, 265, yPosition);
          doc.setLineWidth(0.01);
          doc.line(10, yPosition + 2, pageWidth - 10, yPosition + 2);
          yPosition += 10;
          doc.setTextColor("#000000");
        });
      });
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        const pageNumber = `Page ${i}`;
        const pageNumberX = (pageWidth - doc.getTextWidth(pageNumber)) / 2;
        doc.setFontSize(10);
        doc.text(pageNumber, pageNumberX, pageHeight - 10);
      }

      doc.save("CustomerLedger.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
      WarningAlert("An error occurred while generating the PDF.");
    }
  };


  const filteredEntries = Record.entries.filter((entry) =>
    entry.customerName.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <>
      <div className="flex px-10 gap-3 py-1 bg-secondary justify-center items-center border-b border-Old_Silver">
        <div // fromDate
          className={
            "flex text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
            (props.fromDate.hidden ? " hidden " : " flex ")
          }
        >
          <label className={"w-fit  min-w-[100px] max-w-full"}>
            From Date
            {props.fromDate.mandatory && (
              <span className="text-[#ff2828] text-[14px] h-fit">*</span>
            )}
          </label>
          <input
            className={
              "w-full border-b border-Old_Silver border-opacity-35 font-medium disabled:bg-[#c6c6ca]   text-black disabled:bg-opacity-20 px-2 py-1 " +
              (props.fromDate.mandatory && props.fromDate.show
                ? " rounded-2xl border-2 border-[#ff2828] "
                : "")
            }
            id={"fromDate"}
            type="date"
            value={Record.fromDate.split("T")[0]}
            disabled={props.fromDate.readonly}
            onChange={(event) => {
              console.log("fromDate new Tsate");
              if (
                new Date(event.target.value + "T00:00:00Z") <
                new Date(Record.ToDate)
              ) {
                handleFieldChange(
                  "fromDate",
                  event.target.value + "T00:00:00Z"
                );
                loadRecord(event.target.value + "T00:00:00Z", Record.ToDate);
              } else {
                handleMultiFieldChange({
                  fromDate: event.target.value + "T00:00:00Z",
                  ToDate: event.target.value + "T23:59:59Z",
                });
                loadRecord(
                  event.target.value + "T00:00:00Z",
                  event.target.value + "T23:59:59Z"
                );
              }
            }}
          />
        </div>
        <div // ToDate
          className={
            "flex text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
            (props.ToDate.hidden ? " hidden " : " flex ")
          }
        >
          <label className={"w-fit  min-w-[100px] max-w-full"}>
            To Date
            {props.ToDate.mandatory && (
              <span className="text-[#ff2828] text-[14px] h-fit">*</span>
            )}
          </label>
          <input
            className={
              "w-full border-b border-Old_Silver border-opacity-35 font-medium disabled:bg-[#c6c6ca]   text-black disabled:bg-opacity-20 px-2 py-1 " +
              (props.ToDate.mandatory && props.ToDate.show
                ? " rounded-2xl border-2 border-[#ff2828] "
                : "")
            }
            id={"ToDate"}
            type="date"
            value={Record.ToDate.split("T")[0]}
            disabled={props.ToDate.readonly}
            onChange={(event) => {
              if (
                new Date(Record.fromDate) <
                new Date(event.target.value + "T23:59:59Z")
              ) {
                handleFieldChange("ToDate", event.target.value + "T23:59:59Z");
                loadRecord(Record.fromDate, event.target.value + "T23:59:59Z");
              } else {
                WarningAlert(
                  "The 'To Date' cannot be earlier than the 'From Date'"
                );
              }
            }}
          />
        </div>
        <div className="flex gap-5 items-center">
        
          <div className="relative">
            <input
              type="text"
              placeholder="Search Customer Name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="px-4 py-1 py-1 border border-gray-300 rounded-xl text-sm" 
            />
            <span className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none text-gray-400">
              <svg className="h-4 w-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" ><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
            </span>
          </div> 
          <button
            className={
              "py-2 px-6 rounded-xl font-bold text-[12px] bg-primary text-secondary"
            }
            onClick={ExportExcel}
          >
            EXCEL
          </button>
          <button
            className={
              "py-2 px-6 rounded-xl font-bold text-[12px] bg-primary text-secondary"
            }
            onClick={ExportPDF}
          >
            PDF
          </button>
        </div>
      </div>


      <div className="flex  h-[90%] px-3 pt-2 bg-secondary rounded-lg overflow-x-auto">
        <div className="w-fit p-2 ">
          <table className="w-fit">
            <thead className=" bg-Azureish_White">
              <th className="min-w-[380px] text-left px-2 text-nowrap  ">
                Account Name
              </th>
              <th className="min-w-[140px] text-left px-2 text-nowrap  border-l">
                Account Name
              </th>
              <th className="min-w-[140px] text-left px-2 text-nowrap  border-l">
                Invoice Date
              </th>
              <th className="min-w-[140px] text-left px-2 text-nowrap  border-l">
                Invoice Due Date
              </th>
              <th className="min-w-[140px] text-left px-2 text-nowrap  border-l">
                Over Due Days
              </th>
              <th className="min-w-[140px] text-left px-2 text-nowrap  border-l">
                Debit
              </th>
              <th className="min-w-[140px] text-left px-2 text-nowrap  border-l">
                Credit
              </th>
            </thead>
            <tbody>
              {filteredEntries.map((item, index) => (
                <>
                  <tr
                    key={index}
                    className="border-b border-tertiary hover:bg-Azureish_White cursor-pointer"
                    onClick={() => {
                      let entries = filteredEntries;
                      if (item.show) {
                        entries[index].show = false;
                      } else {
                        entries[index].show = true;
                      }
                      handleFieldChange("entries", entries);
                    }}
                  >
                    <td className="min-w-[380px] text-left px-2">
                      <span className="text-[12px]">
                        {item.show ? "▼ " : "► "}
                      </span>
                      {item.customerName}
                    </td>
                    <td
                      className={"min-w-[140px] px-2 pt-1 border-l text-nowrap"}
                    >
                      {item.ledgerName}
                    </td>
                    <td className={"min-w-[140px] px-2 pt-1 border-l"}>{""}</td>
                    <td className={"min-w-[140px] px-2 pt-1 border-l"}>{""}</td>
                    <td className={"min-w-[140px] px-2 pt-1 border-l"}>{""}</td>
                    <td
                      className={
                        "min-w-[140px] px-2 pt-1 border-l" +
                        (item.totalLedgerDebit == 0
                          ? "   text-black "
                          : " text-primary font-medium ")
                      }
                    >
                      {RupeeFormat(item.totalLedgerDebit)}
                    </td>
                    <td
                      className={
                        "min-w-[140px] px-2 pt-1 border-l" +
                        (item.totalLedgerCredit == 0
                          ? "   text-black "
                          : " text-primary font-medium ")
                      }
                    >
                      {RupeeFormat(item.totalLedgerCredit)}
                    </td>
                  </tr>
                  {item.show &&
                    item.invoices.map((invoice, invIndex) => (
                      <>
                        {/* Invoice Row */}
                        <tr
                          key={`inv-${invIndex}`}
                          className="border-b border-tertiary hover:bg-Azureish_White cursor-pointer group"
                          onClick={() => {
                            let entries = [...Record.entries];
                            entries[index].invoices[invIndex].show = !entries[index].invoices[invIndex].show;
                            handleFieldChange("entries", entries);
                          }}
                        >
                          <td className="min-w-[380px] text-[#344cb7] pl-8">
                            <span className="text-[12px]">
                              {invoice.show ? "▼ " : "► "}
                            </span>
                            &nbsp;&nbsp;

                            <span
                              onClick={() =>
                                store.navTo(`/${URLPRIFIX}/${companyId}/accounts/invoice/view/${invoice.invoiceId}`)
                              }
                              className="cursor-pointer hover:underline"
                            >
                              {invoice.invoiceNo}
                            </span>
                          </td>

                          <td className="min-w-[140px] px-2 pt-1 border-l text-nowrap">
                            {item.ledgerName}
                          </td>
                          <td className="min-w-[140px] px-2 pt-1 border-l text-nowrap">
                            {invoice.invoiceDate?.split("T")[0]}
                          </td>
                          <td className="min-w-[140px] px-2 pt-1 border-l text-nowrap">
                            {invoice.invoiceDueDate?.split("T")[0] || "--"}
                          </td>
                          <td className="min-w-[140px] px-2 pt-1 border-l text-nowrap">
                            {invoice.overduedays || "--"}
                          </td>
                          <td className="min-w-[140px] px-2 pt-1 border-l text-primary font-medium">
                            {RupeeFormat(invoice.invoiceAmount)}
                          </td>
                          <td className="min-w-[140px] px-2 pt-1 border-l text-primary font-medium">
                            {RupeeFormat(invoice.totalPaid)}
                          </td>
                        </tr>

                        {/* Payment Rows */}
                        {invoice.show && invoice.payments?.map((payment, payIndex) => (
                          <tr
                            key={`pay-${payIndex}`}
                            className="border-b border-tertiary hover:bg-Azureish_White cursor-pointer group"
                            onClick={() => {
                              switch (payment.paymentType.toLowerCase()) {
                                case "receipt":
                                  store.navTo(`/${URLPRIFIX}/${companyId}/accounts/receipt/view/${payment.receiptId}`);
                                  break;
                                case "journal":
                                  store.navTo(`/${URLPRIFIX}/${companyId}/accounts/journal/view/${payment.receiptId}`);
                                  break;
                                default:
                                  break;
                              }
                            }}
                          >
                            <td className="min-w-[380px] pl-16 text-gray-700">
                              {payment.receiptNo}
                            </td>
                            <td className="min-w-[140px] px-2 pt-1 border-l text-nowrap">
                              {payment.paymentType}
                            </td>
                            <td className="min-w-[140px] px-2 pt-1 border-l text-nowrap">
                              {payment.receiptDate?.split("T")[0]}
                            </td>
                            <td className="min-w-[140px] px-2 pt-1 border-l">--</td>
                            <td className="min-w-[140px] px-2 pt-1 border-l">--</td>
                            <td className="min-w-[140px] px-2 pt-1 border-l text-primary font-medium">
                              {RupeeFormat(payment.paymentAmount)}
                            </td>
                            <td className="min-w-[140px] px-2 pt-1 border-l">--</td>
                          </tr>
                        ))}
                      </>
                    ))}

                </>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CustomerLedger;
